import { styled } from 'styles';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.blackLight};
  border-radius: 4px;
  padding: 24px 16px;
`;

export const GlobeImage = styled.img`
  margin-right: 8px;
  width: 24px;
  height: 24px;
  opacity: 0.5;
`;

export const ExchangeLabel = styled.span`
  font-size: 1.6rem;
  font-weight: ${({ theme }) => theme.fonts.mediumWeight};
`;

export const Pair = styled.span`
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.dirtyWhite};
  text-transform: uppercase;
`;
